export default "__VITE_ASSET__Dra1jvl9__"